export default __webpack_public_path__ + "static/media/bar.4a94a15f.svg";